import {
    handleActions,
    Action,
} from 'redux-actions';
import {QC_REPORTS_NOTES_SET, QC_REPORTS_NOTES_RESET} from './QCReportsNotesActions';
import {
    QCReportReasonNote,
    QCReportsNotesState,
} from '../../QCReportsReasonsTypes';

export const setQcReportsNotes = (state: QCReportsNotesState, action: Action<QCReportReasonNote[]>) => {
    const {payload} = action;
    
    return {
        data: payload,
        isLoading: false,
    };
};

export const resetQcReportsReasons = () => {
    return initialState;
};

export const initialState = {
    data: [],
    isLoading: true,
};

const handlers = {
    [QC_REPORTS_NOTES_SET]: setQcReportsNotes,
    [QC_REPORTS_NOTES_RESET]: resetQcReportsReasons,
};

export default handleActions<QCReportsNotesState, QCReportReasonNote[]>(handlers, initialState);
